import Controller from "./events.controller";
import template from "./events.html";

const events = {
  template,
  controller: Controller,
};

export default events;



// WEBPACK FOOTER //
// ./src/pages/events/events.component.js